import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=237c9a27&"
import script from "./InfoItem.vue?vue&type=script&lang=js&"
export * from "./InfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports